(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-with-select"] && !Shopify.designMode) return;
  try {
    
class CustomHero extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.button = this.querySelector('.custom-hero__select-button');
    this.list = this.querySelector('.custom-hero__nav-list');
    this.setupEventListeners();
  }

  setupEventListeners() {
    if (!this.button || !this.list) return;

    this.button.addEventListener('click', this.toggleDropdown.bind(this));
    document.addEventListener('click', this.handleClickOutside.bind(this));
    
    // Initialize the dropdown state
    this.list.hidden = true;
    this.button.setAttribute('aria-expanded', 'false');
  }

  toggleDropdown() {
    const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', !isExpanded);
    this.list.hidden = isExpanded;
    
    if (!isExpanded) {
      // Add active state styling
      this.button.classList.add('is-active');
    } else {
      this.button.classList.remove('is-active');
    }
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.button.setAttribute('aria-expanded', 'false');
      this.list.hidden = true;
      this.button.classList.remove('is-active');
    }
  }
}

customElements.define('hero-with-select', CustomHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ready-for-bed"] && !Shopify.designMode) return;
  try {
    
  class ReadyForBed extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.button = this.querySelector('.ready-for-bed__select-button');
      this.list = this.querySelector('.ready-for-bed__nav-list');
      this.setupEventListeners();
    }

    setupEventListeners() {
      if (!this.button || !this.list) return;

      this.button.addEventListener('click', this.toggleDropdown.bind(this));
      document.addEventListener('click', this.handleClickOutside.bind(this));
      
      // Initialize the dropdown state
      this.list.hidden = true;
      this.button.setAttribute('aria-expanded', 'false');
    }

  toggleDropdown() {
    const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
    this.button.setAttribute('aria-expanded', !isExpanded);
    this.list.hidden = isExpanded;
    
    if (!isExpanded) {
      this.button.classList.add('is-active');
    } else {
      this.button.classList.remove('is-active');
    }
  }

    positionDropdown() {
      const buttonRect = this.button.getBoundingClientRect();
      this.list.style.position = 'fixed';
      this.list.style.left = `${buttonRect.left}px`;
      this.list.style.top = `${buttonRect.bottom}px`;
      this.list.style.width = `${buttonRect.width}px`;
    }

    handleClickOutside(event) {
      if (!this.contains(event.target)) {
        this.button.setAttribute('aria-expanded', 'false');
        this.list.hidden = true;
        this.button.classList.remove('is-active');
      }
    }
  }

  customElements.define('ready-for-bed', ReadyForBed);

  } catch(e) { console.error(e); }
})();
})();
